import { SyncAmbulatoryToken } from 'domain/usecases/ambulatory/sync-ambulatory-token'
import { AmbulatoryRepository } from 'repository/interfaces/ambulatory-repository'

export class RemoteSyncAmbulatoryToken implements SyncAmbulatoryToken {
  private readonly ambulatoryRepository: AmbulatoryRepository

  constructor(ambulatoryRepository: AmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  async sync(
    params: SyncAmbulatoryToken.Params
  ): Promise<SyncAmbulatoryToken.Model> {
    return await this.ambulatoryRepository.syncAmbulatoryToken(params)
  }
}
